import React from "react";
import { FILTER_OPTIONS } from "./constants";

interface DashboardHeaderProps {
  dateFilter: number | null;
  onDateFilterChange: (value: number) => void;
}

export default function DashboardHeader({
  dateFilter,
  onDateFilterChange,
}: DashboardHeaderProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h4 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
          Acompanhamento de Alimentação
        </h4>
        <p className="mt-1 text-xs sm:text-sm text-gray-600 dark:text-gray-400">
          Acompanhe o consumo calórico e hábitos alimentares do aluno
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        {FILTER_OPTIONS.map((option) => (
          <button
            key={option.label}
            onClick={() => onDateFilterChange(option.value)}
            className={`rounded-lg sm:rounded-md px-3 py-2 sm:py-1.5 text-xs sm:text-sm font-medium transition active:scale-95 touch-manipulation ${
              dateFilter === option.value
                ? "bg-purple-600 text-white shadow-sm"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-meta-4 dark:text-gray-300 dark:hover:bg-opacity-80"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
